export default {"src":"/_next/static/media/carOutline25_24.d7d1ccf7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};